import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';

import { Alertc, AlertcLinear } from 'app/models';
import { DirectionType } from 'app/models/enums';
import { CbmInputStyle } from 'app/shared/input/cbm-input-style';
import { enumValues } from 'app/shared/util/enumValues';

@Component({
  selector: 'linear-vild',
  templateUrl: './linear-vild.component.html',
  styleUrls: ['./linear-vild.component.scss']
})
export class LinearVildComponent implements OnInit, OnChanges {
  @Input() readonly: boolean;
  @Input() required: boolean;
  @Input() inputStyle: CbmInputStyle;
  @Input() type: string;
  @Input() index: number;
  @Input() alertcLinear: AlertcLinear;
  @Input() open = false;

  @ViewChild('body') body: ElementRef;

  @Output() deleteVildSegement: EventEmitter<number> = new EventEmitter<number>();
  @Output() addVildSegement: EventEmitter<number> = new EventEmitter<number>();

  public primaryAlertc: Alertc = new Alertc();
  public secondaryAlertc: Alertc = new Alertc();

  public directionTypes: string[];

  constructor(private readonly renderer: Renderer2) {}

  ngOnInit(): void {
    this.directionTypes = enumValues(DirectionType);
    this.primaryAlertc = this.primaryAlertc.getPrimaryAlertc(this.alertcLinear);
    this.secondaryAlertc = this.secondaryAlertc.getSecondaryAlertc(this.alertcLinear);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.readonly && changes.readonly.currentValue === true) {
      this.primaryAlertc = this.primaryAlertc.getPrimaryAlertc(this.alertcLinear);
      this.secondaryAlertc = this.secondaryAlertc.getSecondaryAlertc(this.alertcLinear);
    }
  }

  public collapse(open?: boolean): void {
    if (open == null) {
      if (this.body.nativeElement.classList.contains('in')) {
        this.closeItem();
      } else {
        this.openItem();
      }
    } else if (open) {
      this.openItem();
    } else {
      this.closeItem();
    }
  }

  private openItem(): void {
    this.renderer.addClass(this.body.nativeElement, 'in');
  }

  private closeItem(): void {
    this.renderer.removeClass(this.body.nativeElement, 'in');
  }

  private removeVildSegment(): void {
    this.deleteVildSegement.emit(this.alertcLinear.alertcIndex);
  }

  private addVildSegment(): void {
    this.addVildSegement.emit(this.alertcLinear.alertcIndex);
  }

  public getAlerttcLinear(): AlertcLinear {
    this.alertcLinear.primaryVildLocation = this.primaryAlertc.vildLocation;
    this.alertcLinear.primaryOffsetDistance = this.primaryAlertc.offsetDistance;
    this.alertcLinear.endLatitude = this.primaryAlertc.latitude;
    this.alertcLinear.endLongitude = this.primaryAlertc.longitude;
    this.alertcLinear.carriagewayEndpoint = this.primaryAlertc.carriageway;

    this.alertcLinear.secondaryVildLocation = this.secondaryAlertc.vildLocation;
    this.alertcLinear.secondaryOffsetDistance = this.secondaryAlertc.offsetDistance;
    this.alertcLinear.startLatitude = this.secondaryAlertc.latitude;
    this.alertcLinear.startLongitude = this.secondaryAlertc.longitude;
    this.alertcLinear.carriagewayStartpoint = this.secondaryAlertc.carriageway;

    this.alertcLinear.displayLatitude = this.secondaryAlertc.latitude;
    this.alertcLinear.displayLongitude = this.secondaryAlertc.longitude;

    return this.alertcLinear;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/vild/linear/linear-vild.component.ts